<template>
  <div class="gs-share" @click.stop>
    <button
      type="button"
      class="gs-share-btn"
      :class="{ 'is-open': open, 'is-link': variant === 'link' }"
      :title="buttonText"
      @click.stop.prevent="toggle"
    >
      <svg class="gs-share-icon" viewBox="0 0 24 24" aria-hidden="true">
        <path
          fill="currentColor"
          d="M18 8a3 3 0 1 0-2.83-4H15a3 3 0 0 0 0 6c.37 0 .72-.07 1.04-.2l-6.1 3.56A3 3 0 0 0 6 12a3 3 0 0 0 0 6 3 3 0 0 0 2.94-2.42l6.1 3.56c-.32.13-.67.2-1.04.2a3 3 0 1 0 3-3c-.37 0-.72.07-1.04.2l-6.1-3.56A3.02 3.02 0 0 0 10 13c0-.37.07-.72.2-1.04l6.1-3.56c.32.13.67.2 1.04.2Z"
        />
      </svg>
      <span>{{ buttonText }}</span>
    </button>
    <teleport to="body">
      <div
        v-show="open"
        ref="menu"
        class="gs-share-menu"
        :class="{ 'is-wechat': wechatOpen, 'has-copy': !!copyHint }"
        :style="menuStyle"
        @click.stop
      >
        <div class="gs-share-title">分享到</div>
        <div class="gs-share-row">
          <button type="button" class="gs-share-item" @click="shareQQ">
            <img class="gs-share-img" src="@/assets/images/share/qq.svg" alt="">
            <span>QQ</span>
          </button>
          <button type="button" class="gs-share-item" @click="shareWeibo">
            <img class="gs-share-img" src="@/assets/images/share/weibo.svg" alt="">
            <span>微博</span>
          </button>
          <button type="button" class="gs-share-item" @click="shareWechat">
            <img class="gs-share-img" src="@/assets/images/share/moments.svg" alt="">
            <span>朋友圈</span>
          </button>
          <button type="button" class="gs-share-item" @click="copyLink">
            <img class="gs-share-img" src="@/assets/images/share/link.svg" alt="">
            <span>复制链接</span>
          </button>
        </div>
        <div v-if="wechatOpen" class="gs-share-wechat">
          <div ref="qrWrap" class="gs-share-qr"></div>
          <p>微信扫一扫，分享到朋友圈</p>
        </div>
        <div v-if="copyHint" class="gs-share-copy">
          <input ref="copyInput" class="gs-share-copy-input" :value="copyHint" readonly>
          <p>请按 Ctrl+C 复制</p>
        </div>
      </div>
    </teleport>
  </div>
</template>

<script>
import QRCode from 'qrcode'
import { ElMessage } from 'element-plus'
import { P } from '@/router/paths'

export default {
  name: 'GsShare',
  props: {
    id: { type: [String, Number], default: '' },
    url: { type: String, default: '' },
    path: { type: String, default: '' },
    title: { type: String, default: '' },
    summary: { type: String, default: '' },
    image: { type: String, default: '' },
    buttonText: { type: String, default: '分享' },
    variant: { type: String, default: 'button' }
  },
  data() {
    return {
      open: false,
      wechatOpen: false,
      copyHint: '',
      menuStyle: {}
    }
  },
  computed: {
    shareUrl() {
      if (this.url) return this.url
      const origin = this.publicOrigin()
      if (this.path) {
        const path = this.path.charAt(0) === '/' ? this.path : `/${this.path}`
        return `${origin}${path}`
      }
      return `${origin}${P.newsDetail(this.id)}`
    },
    shareTitle() {
      return (this.title || '国数网').replace(/\s+/g, ' ').trim()
    },
    shareSummary() {
      return String(this.summary || '')
        .replace(/<[^>]+>/g, '')
        .replace(/\s+/g, ' ')
        .trim()
        .slice(0, 120)
    },
    shareImage() {
      const src = this.image || ''
      if (!src) return ''
      if (/^https?:\/\//i.test(src)) return src
      return `${this.publicOrigin()}${src.charAt(0) === '/' ? '' : '/'}${src}`
    }
  },
  watch: {
    open(val) {
      if (val) this.$nextTick(this.syncMenu)
      else {
        this.wechatOpen = false
        this.copyHint = ''
      }
    },
    wechatOpen(val) {
      if (val) {
        this.$nextTick(() => {
          this.syncMenu()
          this.drawQr()
        })
      }
    }
  },
  mounted() {
    this._onDoc = (event) => {
      if (this.$el && this.$el.contains(event.target)) return
      if (this.$refs.menu && this.$refs.menu.contains(event.target)) return
      this.open = false
    }
    this._onReposition = () => {
      if (this.open) this.syncMenu()
    }
    document.addEventListener('mousedown', this._onDoc)
    window.addEventListener('resize', this._onReposition)
    window.addEventListener('scroll', this._onReposition, true)
  },
  beforeUnmount() {
    this.unbindGlobal()
  },
  beforeDestroy() {
    this.unbindGlobal()
  },
  methods: {
    publicOrigin() {
      if (typeof window === 'undefined') return 'https://shujuzichan.com'
      const origin = window.location.origin || ''
      if (/^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/i.test(origin)) {
        return 'https://shujuzichan.com'
      }
      return origin
    },
    unbindGlobal() {
      document.removeEventListener('mousedown', this._onDoc)
      window.removeEventListener('resize', this._onReposition)
      window.removeEventListener('scroll', this._onReposition, true)
    },
    syncMenu() {
      const el = this.$el
      if (!el) return
      const rect = el.getBoundingClientRect()
      const width = this.wechatOpen || this.copyHint ? 280 : 268
      let left = rect.right - width
      left = Math.min(Math.max(8, left), window.innerWidth - width - 8)
      const estimated = this.wechatOpen ? 320 : 120
      const spaceBelow = window.innerHeight - rect.bottom - 8
      const openUp = spaceBelow < estimated && rect.top > spaceBelow
      this.menuStyle = {
        position: 'fixed',
        left: `${left}px`,
        width: `${width}px`,
        zIndex: 5000,
        top: openUp ? 'auto' : `${rect.bottom + 6}px`,
        bottom: openUp ? `${window.innerHeight - rect.top + 6}px` : 'auto'
      }
    },
    toggle() {
      this.open = !this.open
    },
    popup(href) {
      window.open(href, '_blank', 'noopener,noreferrer,width=720,height=560')
      this.open = false
    },
    shareQQ() {
      const params = new URLSearchParams({
        url: this.shareUrl,
        title: this.shareTitle,
        summary: this.shareSummary,
        desc: this.shareSummary,
        pics: this.shareImage,
        site: '国数网'
      })
      this.popup(`https://connect.qq.com/widget/shareqq/index.html?${params.toString()}`)
    },
    shareWeibo() {
      const params = new URLSearchParams({
        url: this.shareUrl,
        title: this.shareTitle,
        pic: this.shareImage,
        searchPic: 'false'
      })
      this.popup(`https://service.weibo.com/share/share.php?${params.toString()}`)
    },
    shareWechat() {
      this.wechatOpen = true
    },
    drawQr() {
      const wrap = this.$refs.qrWrap
      if (!wrap) return
      wrap.innerHTML = ''
      const canvas = document.createElement('canvas')
      wrap.appendChild(canvas)
      QRCode.toCanvas(canvas, this.shareUrl, {
        width: 148,
        margin: 1,
        color: { dark: '#0165FF', light: '#ffffff' }
      })
    },
    fallbackCopy(text) {
      const input = document.createElement('textarea')
      input.value = text
      input.setAttribute('readonly', 'readonly')
      input.style.position = 'fixed'
      input.style.left = '-9999px'
      document.body.appendChild(input)
      input.select()
      const ok = document.execCommand('copy')
      document.body.removeChild(input)
      return ok
    },
    copyLink() {
      const url = this.shareUrl
      const done = () => {
        ElMessage.success('链接已复制')
        this.open = false
      }
      const showManual = () => {
        this.copyHint = url
        this.$nextTick(() => {
          const input = this.$refs.copyInput
          if (input) {
            input.focus()
            input.select()
          }
          this.syncMenu()
        })
        ElMessage.info('请按 Ctrl+C 复制')
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done).catch(() => {
          if (this.fallbackCopy(url)) done()
          else showManual()
        })
        return
      }
      if (this.fallbackCopy(url)) done()
      else showManual()
    }
  }
}
</script>

<style lang="css" scoped>
.gs-share {
  display: inline-flex;
  flex-shrink: 0;
  vertical-align: middle;
}
.gs-share-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 28px;
  padding: 0 10px;
  border: 1px solid #D7DEE8;
  border-radius: 4px;
  background: #F4F6F8;
  color: #4B5563;
  font-size: 12px;
  line-height: 1;
  cursor: pointer;
  white-space: nowrap;
  font-family: inherit;
}
.gs-share-btn:hover,
.gs-share-btn.is-open {
  border-color: #0165FF;
  color: #0165FF;
  background: #EEF4FF;
}
.gs-share-btn.is-link {
  height: auto;
  padding: 0;
  border: 0;
  background: transparent;
  color: #0165FF;
  font-size: 14px;
}
.gs-share-icon {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}
</style>

<style lang="css">
.gs-share-menu {
  box-sizing: border-box;
  padding: 12px 14px 14px;
  background: #fff;
  border: 1px solid #E6EAF0;
  border-radius: 10px;
  box-shadow: 0 10px 28px rgba(17, 24, 36, 0.14);
}
.gs-share-title {
  font-size: 12px;
  color: #6B7280;
  margin-bottom: 10px;
}
.gs-share-row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 4px;
}
.gs-share-item {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 6px 2px 2px;
  border: 0;
  background: transparent;
  color: #3D4A5C;
  font-size: 11px;
  line-height: 1.2;
  cursor: pointer;
  font-family: inherit;
}
.gs-share-item:hover {
  color: #0165FF;
}
.gs-share-img {
  width: 28px;
  height: 28px;
  display: block;
  object-fit: contain;
}
.gs-share-wechat {
  margin-top: 12px;
  text-align: center;
}
.gs-share-qr {
  width: 148px;
  height: 148px;
  margin: 0 auto;
}
.gs-share-qr canvas {
  display: block;
  width: 148px !important;
  height: 148px !important;
}
.gs-share-wechat p,
.gs-share-copy p {
  margin: 8px 0 0;
  font-size: 12px;
  color: #6B7280;
  line-height: 1.4;
}
.gs-share-copy {
  margin-top: 10px;
}
.gs-share-copy-input {
  width: 100%;
  box-sizing: border-box;
  height: 32px;
  padding: 0 8px;
  border: 1px solid #D7DEE8;
  border-radius: 4px;
  font-size: 12px;
  color: #111824;
}
</style>
